import UserChangePasswordComponent from './UserChangePasswordComponent';
import UserUpdatePersonalInfo from './UserUpdatePersonalInfo';
// import UserBusinessTypeSetting from './UserBusinessTypeSetting';

export default function UserChangeDetails() {
  return (
    <div className="space-y-8 py-8">
      <UserUpdatePersonalInfo />
      <UserChangePasswordComponent />
      {/* <UserBusinessTypeSetting /> */}
    </div>
  );
}
